import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { BrandBlockStyles as styles } from "./BrandBlock.styles"

/**
 * A component to present the brand information.
 * @param {string} logoImage - Path to the brand logo image.
 * @param {string} logoAlt - Text to present when image is not found
 * @param {string} slogan - Text displayed as a tooltip for logo image.
 * @returns {JSX.Element}
 */
const BrandBlock = ({logoImage, logoAlt, slogan}) => {
  return (
    <Box className="BrandBlock" sx={styles}>
      <a href="/">
        <img src={logoImage} className="BrandBlock__logo" alt={logoAlt} title={slogan || logoAlt}/>
      </a>
    </Box>
  )
}

BrandBlock.propTypes = {
  logoImage: PropTypes.string.isRequired,
  logoAlt: PropTypes.string.isRequired,
  slogan: PropTypes.string,
};

export default React.memo(BrandBlock);
